<template>
  <div class="h-100 custom-visualisation">
    <b-container
      class="min-w-100 mh-100 h-100 vertical-scroll"
      :class="containerClass"
      :style="containerStyle"
    >
      <b-row align-v="center" align-h="center" class="mh-100 h-100">
        <InfoCard :tab-node="activeTabNode" />
      </b-row>
    </b-container>
    <NavBtnReset v-if="showResetBtn" key="reset-btn" class="reset-btn" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import InfoCard from '@/components/public/Visualisations/CustomVisualisation/InfoCard.vue'
import NavBtnReset from '@/components/public/NavButtons/NavBtnReset.vue'
import { NavButtonKeys } from '@/types'
import { useNavButtonsStore } from '@/store/public/navButtons'

const components = {
  InfoCard,
  NavBtnReset,
}

@Component({ components })
export default class CustomVisualisation extends Vue {
  get activeTabNode() {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.nodes
      .activeCustomTabNode
  }

  get backgroundImageId() {
    return this.activeTabNode?.config.backgroundImage?.img
  }

  get showBackgroundImage() {
    return this.backgroundImageId !== undefined
  }

  get containerClass() {
    return { 'custom-visualisation-background': this.showBackgroundImage }
  }

  get containerStyle() {
    if (this.showBackgroundImage) {
      const imageUrl =
        this.$typedStore.activeVisualisation.visualisationStore.entities.images.imageUrl(
          this.backgroundImageId!,
        )
      return { 'background-image': `url(${imageUrl})` }
    }

    return {}
  }

  get isMobile() {
    return this.$typedStore.public.display.isMobile
  }

  get showResetBtn() {
    return useNavButtonsStore().buttonEnabled(NavButtonKeys.RESET) && !this.isMobile
  }
}
</script>

<style scoped>
.custom-visualisation {
  position: relative;
  /* Offset the size of the active tab */
  margin-left: calc(var(--tab-offset) * -1);
}

.custom-visualisation-background {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.reset-btn {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
}
</style>
